import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            &:disabled {
                color: ${getColor("common.disabled")};
            }
        `,
    },
} as xBaseTheme["clickable"];
